import { Button, Grid, Input, InputLabel } from "@material-ui/core";
import { ITextVariable } from "common/interfaces/text-variable.interface";
import React, { useState, useEffect, FunctionComponent } from "react";
import i18next from "i18next";
import "./i18n";
import { Container } from "./styles";
import { IProps } from "./types";

const EditTextVariableView: FunctionComponent<IProps> = (props: IProps) => {
  const [value, setValue] = useState<ITextVariable>(props.textVariable);

  useEffect(() => {
    const newValues = { ...props.textVariable };
    setValue(newValues);
  }, [props.textVariable]);

  const editVariables = () => {
    props.editVariable(value);
  };

  const onChangeName = (event: React.ChangeEvent<HTMLInputElement>) => {
    const item = { ...value };
    item.name = event.target.value;
    setValue(item);
  };

  const onChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const item = { ...value };
    item.value = event.target.value;
    setValue(item);
  };

  const onChangeType = (event: React.ChangeEvent<HTMLInputElement>) => {
    const item = { ...value };
    item.type = event.target.valueAsNumber;
    setValue(item);
  };

  return (
    <Container>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={3}
      >
        <Grid key={value.id} item xs={12} sm={6} spacing={3}>
          <InputLabel id="templates-select-label">name</InputLabel>
          <Input
            value={value.name}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              onChangeName(event)
            }
          />
          <InputLabel id="templates-select-label">value</InputLabel>
          <Input
            value={value.value}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              onChangeValue(event)
            }
          />
          <InputLabel id="templates-select-label">type</InputLabel>
          <Input
            type="number"
            value={value.type}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              onChangeType(event)
            }
          />
        </Grid>
        <Grid item xs={3}>
          <Button variant="contained" color="primary" onClick={editVariables}>
            {i18next.t("EDIT_TEXT_VARIABLE:BUTTON_TEXT")}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};
export default EditTextVariableView;
